import { combineReducers } from '@reduxjs/toolkit';
import cameraReducers from './camera'
export default combineReducers({
    camera: cameraReducers
})